export default __webpack_public_path__ + "media/maps/more-green-ffc1aea4.svg";